var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysiciansResearchDevepolment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88 88",
    enableBackground: "new 0 0 88 88",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000003821980084239148560000006889540897497829021_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.64,
    strokeMiterlimit: 10,
    cx: 35.6,
    cy: 35.6,
    r: 21.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#C1B451",
    strokeWidth: 0.64,
    strokeMiterlimit: 10,
    cx: 35.6,
    cy: 35.6,
    r: 20.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#8A8342",
    strokeWidth: 0.64,
    strokeMiterlimit: 10,
    cx: 35.6,
    cy: 35.6,
    r: 18.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#545134",
    strokeWidth: 0.64,
    strokeMiterlimit: 10,
    cx: 35.6,
    cy: 35.6,
    r: 16.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1D2025",
    strokeWidth: 0.63,
    strokeMiterlimit: 10,
    cx: 35.6,
    cy: 35.6,
    r: 15.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666238",
    strokeWidth: 0.63,
    strokeMiterlimit: 10,
    d: "M52.2,52.2l-0.3-0.3L52,52l16.7,16.7l2.9,2.9 l-2.9-2.9L52,52l-0.2-0.2L52.2,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#968E45",
    strokeWidth: 0.64,
    strokeMiterlimit: 10,
    d: "M51.8,51.8c-0.4,0.4-0.9,0.7-1.4,0.8l0.2,0.2 l17.3,17.3c1.7,1.7,3.5,2.6,4.1,2c0.6-0.6-0.3-2.5-2-4.1L52.7,50.6l-0.1-0.2C52.5,50.9,52.2,51.4,51.8,51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C7B952",
    strokeWidth: 0.64,
    strokeMiterlimit: 10,
    d: "M51.5,51.4c-0.7,0.7-1.6,1.4-2.5,1.8l0.2,0.2 l18,18c1.7,1.7,4.1,2.2,5.3,1c1.2-1.2,0.8-3.6-1-5.3l-18-18c-0.1-0.1-0.1-0.1-0.2-0.2C52.7,49.9,52.2,50.7,51.5,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.64,
    strokeMiterlimit: 10,
    d: "M51.2,51c-1.1,1.1-2.3,2.1-3.7,2.9 c0.1,0.1,0.1,0.1,0.2,0.2l18.6,18.6c1.8,1.8,4.7,1.8,6.5,0c1.8-1.8,1.8-4.7,0-6.5l0,0L54.2,47.7L54,47.5 C53.2,48.8,52.2,50,51.2,51z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysiciansResearchDevepolment);
export default __webpack_public_path__ + "static/media/physiciansResearchDevepolment.f41bbb8124e7656d29aae07729aaf1c4.svg";
export { ForwardRef as ReactComponent };